import { useState } from "react";

import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
  DialogTitle,
  Dialog,
  Box,
  Tabs,
  Tab,
} from "@mui/material";

import Data from "../../../pages/Data";

const innerTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const SENSOR_TYPES = [
  { label: "PM2.5", id: "pm25" },
  { label: "Temperature", id: "temp" },
  { label: "Humidity", id: "humidity" },
  { label: "CO2", id: "co2" },
];

type Props = {
  open: boolean;
  onClose: (refreshData?: boolean) => void;
  unit: any;
};

const UnitData = ({ open, onClose, unit }: Props) => {
  const [sensorType, setSensorType] = useState<number>(0);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={innerTheme}>
        <Dialog
          PaperProps={{ style: { backgroundColor: "#162B56" } }}
          fullWidth
          maxWidth="xl"
          {...{ open }}
          onClose={() => onClose()}
        >
          <DialogTitle fontSize={24}>
            Unit Data (DEVICE ID: {unit.uid})
          </DialogTitle>
          <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "15px" }}>
            <Tabs
              value={sensorType}
              onChange={(e, v) => setSensorType(v)}
              variant="fullWidth"
            >
              {SENSOR_TYPES.map((el) => {
                return <Tab label={el.label} id={el.id} />;
              })}
            </Tabs>
          </Box>
          <Data
            device_id={unit.uid}
            pageTitle="Device Data"
            sensorType={SENSOR_TYPES[sensorType].id as any}
            showDatePicker
          />
        </Dialog>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default UnitData;
